import BaseEnum from "./base_enum.js.jsx";

class TitleEnumDesc extends BaseEnum {

  name() {
    return "title";
  }

  rawValues() {
    return ["doctor", "professor", "professor_doctor", "diverse", "ag", "ev", "gbr", "gmbh", "cokg", "kg", "kgaa", "ohg", "se", "stiftung", "ug"];
  }

}

const TitleEnum = new TitleEnumDesc();
export default TitleEnum;
